import Vue from 'vue';

const state = {
	featureFlags: {},
    featureFlagsLoading: false,
    featureFlagsLoaded: false,
	featureFlagsTenantId: null
};

const getters = {
	isFeatureEnabled: (state, getters, rootState) => (featureName) => {
		if (!state.featureFlagsLoaded) return false;
		if (state.featureFlagsTenantId !== rootState.tenantId) return false;

        return state.featureFlags[featureName];
    }
};

const actions = {
	getFeatureFlags({ commit, rootState }) {
		commit('GET_PENDING', rootState.tenantId);
		return Vue.axios
			.get(`/api/${rootState.tenantId}/featureFlags`)
			.then(response => {
				commit('GET_SUCCESS', {
					tenantId: rootState.tenantId,
					featureFlags: response.data
				});
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	enableFeature({ commit, rootState }, featureName) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/featureFlags/toggle/${featureName}`, { status: true })
				.then(resp => {
					commit('FEATURE_ENABLED', featureName);
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	disableFeature({ commit, rootState }, featureName) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/featureFlags/toggle/${featureName}`, { status: false })
				.then(resp => {
					commit('FEATURE_DISABLED', featureName);
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
};

const mutations = {
	GET_PENDING(state, tenantId) {
		state.featureFlagsLoading = true;
		state.featureFlagsLoaded = false;
		state.featureFlagsTenantId = tenantId;
	},
	GET_SUCCESS(state, data) {
		state.featureFlagsLoading = false;
        state.featureFlagsLoaded = true;
		state.featureFlagsTenantId = data.tenantId;
		state.featureFlags = data.featureFlags;
	},
	GET_FAILURE(state, error) {
		state.featureFlagsLoading = false;
	},
	FEATURE_ENABLED(state, featureName) {
		if (state.featureFlags.hasOwnProperty(featureName)) {
			state.featureFlags[featureName] = true;
		}
	},
	FEATURE_DISABLED(state, featureName) {
		if (state.featureFlags.hasOwnProperty(featureName)) {
			state.featureFlags[featureName] = false;
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
